module.exports = __webpack_public_path__ + "static/media/brandTictrac.79cae7bf.jpg";